<template>
    <page-view title="项目服务费统计">
        <template #action>
            <a-select v-model="year" placeholder="选择年份" size="large" style="width: 200px">
                <a-select-option v-for="y in yearArr" :key="y.year1" :value="y.year1">
                    {{y.year1}}年
                </a-select-option>
            </a-select>
        </template>

        <a-spin :spinning="spinning" tip="加载中...">
            <!-- KPI 卡片 -->
            <div class="kpi-cards-container">
                <a-row :gutter="16">
                    <a-col v-for="(kpi, index) in kpiData" :key="index" :xs="24" :sm="12" :lg="6">
                        <a-card :class="['kpi-card', kpi.type]">
                            <div class="kpi-content">
                                <div class="kpi-icon"><a-icon :type="kpi.icon" /></div>
                                <div class="kpi-details">
                                    <div class="kpi-label">{{kpi.label}}</div>
                                    <div class="kpi-value">{{kpi.value}}</div>
                                </div>
                            </div>
                        </a-card>
                    </a-col>
                </a-row>
            </div>

            <!-- 收款率 -->
            <a-card class="mb-4 rate-card" :bordered="false">
                <div class="rate-content">
                    <span class="rate-label">整体收款率</span>
                    <div class="rate-value">
                        <span class="rate-number">{{collectionRate}}%</span>
                        <a-progress
                            :percent="Number(collectionRate)"
                            :show-info="false"
                            :stroke-color="{ '0%': '#108ee9', '100%': '#87d068' }"
                            class="rate-progress"
                        />
                    </div>
                </div>
            </a-card>

            <!-- 图表 -->
            <a-row :gutter="16">
                <a-col :xs="24" :lg="12">
                    <a-card title="公司服务费统计" :bordered="false" class="chart-card mb-4">
                        <piechart ref="fwfPiechart" id="fwfPiechart" :echarStyle="{width: '100%', height: '320px'}" />
                    </a-card>
                </a-col>
                <a-col :xs="24" :lg="12">
                    <a-card title="部门服务费统计" :bordered="false" class="chart-card mb-4">
                        <multi-barchart ref="fwfMultiBarchart" id="fwfMultiBarchart" :echarStyle="{width: '100%', height: '320px'}" />
                    </a-card>
                </a-col>

                <!-- 部门表格 -->
                <a-col :xs="24">
                    <a-card title="部门详细数据" :bordered="false" class="table-card mb-4">
                        <a-table
                            :columns="deptColumns"
                            :data-source="deptData"
                            :pagination="false"
                            :scroll="{ x: 1200 }"
                            row-key="tenderDept"
                            bordered>
                            <template #tenderDept="text"><span class="dept-name">{{text}}</span></template>
                            <template #xmsl="text"><a-tag color="blue">{{text}}</a-tag></template>
                            <template #fwje="text"><span class="money-text">¥{{text|NumberFormat2}}</span></template>
                            <template #yjfwf="text"><span class="money-text money-received">¥{{text|NumberFormat2}}</span></template>
                            <template #djfwf="text"><span class="money-text money-pending">¥{{text|NumberFormat2}}</span></template>
                            <template #rate="text">
                                <div class="rate-cell">
                                    <a-progress
                                        :percent="Number(text)"
                                        :width="50"
                                        :stroke-color="getRateColor(text)"
                                        :format="p => `${p}%`"
                                        type="circle"
                                    />
                                </div>
                            </template>
                        </a-table>
                    </a-card>
                </a-col>
            </a-row>
        </a-spin>
    </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import Piechart from './Piechart'
import MultiBarchart from './MultiBarchart'
import moment from 'moment'

export default {
    name: 'ProjectStatisticsIndexFwf',
    components: { PageView, Piechart, MultiBarchart },
    data() {
        return {
            spinning: true,
            conmany: {},
            deptData: [],
            yearArr: [],
            year: String(moment().year() - 1),
            deptColumns: [
                { title: '部门', dataIndex: 'tenderDept', key: 'tenderDept', width: 150, scopedSlots: { customRender: 'tenderDept' }, align: 'center' },
                { title: '项目数量', dataIndex: 'xmsl', key: 'xmsl', width: 120, scopedSlots: { customRender: 'xmsl' }, align: 'center' },
                { title: '应收总金额(元)', dataIndex: 'fwje', key: 'fwje', width: 150, scopedSlots: { customRender: 'fwje' }, align: 'right' },
                { title: '已收金额(元)', dataIndex: 'yjfwf', key: 'yjfwf', width: 150, scopedSlots: { customRender: 'yjfwf' }, align: 'right' },
                { title: '待收金额(元)', dataIndex: 'djfwf', key: 'djfwf', width: 150, scopedSlots: { customRender: 'djfwf' }, align: 'right' },
                { title: '收款率', key: 'rate', width: 150, align: 'center', dataIndex: 'rate', scopedSlots: { customRender: 'rate' } }
            ]
        }
    },
    computed: {
        // KPI 数据
        kpiData() {
            const { xmsl = 0, fwfje = 0, yjfwf = 0, djfwf = 0 } = this.conmany
            return [
                { label: '项目数量', value: xmsl, icon: 'project', type: 'kpi-card-primary' },
                { label: '应收总金额', value: `¥${this.$options.filters.NumberFormat2(fwfje)}`, icon: 'account-book', type: 'kpi-card-info' },
                { label: '已收金额', value: `¥${this.$options.filters.NumberFormat2(yjfwf)}`, icon: 'check-circle', type: 'kpi-card-success' },
                { label: '待收金额', value: `¥${this.$options.filters.NumberFormat2(djfwf)}`, icon: 'clock-circle', type: 'kpi-card-warning' }
            ]
        },
        // 收款率
        collectionRate() {
            const { fwfje = 0, yjfwf = 0 } = this.conmany
            return fwfje === 0 ? '0.00' : ((yjfwf / fwfje) * 100).toFixed(2)
        }
    },
    created() {
        this.initDataCompany()
        this.initDataDept()
        this.initYearData()
    },
    watch: {
        year() {
            this.initDataCompany()
            this.initDataDept()
        }
    },
    methods: {
        // 收款率颜色
        getRateColor(rate) {
            const r = Number(rate)
            if (r >= 80) return '#52c41a'
            if (r >= 60) return '#1890ff'
            if (r >= 40) return '#faad14'
            return '#f5222d'
        },
        // 加载年份数据
        async initYearData() {
            try {
                const res = await this.$http.get('/api/1/bidApply/statistics/getYears.json')
                this.yearArr = res.result
            } catch (e) {}
        },
        // 加载公司数据
        async initDataCompany() {
            this.spinning = true
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getCompanyFwf.json?year=${this.year}`)
                this.conmany = res.result
                this.$nextTick(() => {
                    if (this.$refs.fwfPiechart) {
                        this.$refs.fwfPiechart.refreshData([], [
                            { value: this.conmany.yjfwf, name: '已收' },
                            { value: this.conmany.djfwf, name: '待收' }
                        ], '')
                    }
                })
            } finally {
                this.spinning = false
            }
        },
        // 加载部门数据
        async initDataDept() {
            this.spinning = true
            try {
                const res = await this.$http.get(`/api/1/bidApply/statistics/getDeptFwf.json?year=${this.year}`)
                this.deptData = res.result.map(item => ({
                    ...item,
                    rate: item.fwje === 0 ? '0.00' : ((item.yjfwf / item.fwje) * 100).toFixed(2)
                }))
                const xAxisData = res.result.map(d => d.tenderDept)
                const sourcesData = [
                    { name: '总金额', data: res.result.map(d => d.fwje) },
                    { name: '已收', data: res.result.map(d => d.yjfwf) },
                    { name: '待收', data: res.result.map(d => d.djfwf) }
                ]
                this.$nextTick(() => {
                    if (this.$refs.fwfMultiBarchart) {
                        this.$refs.fwfMultiBarchart.refreshData(sourcesData, xAxisData)
                    }
                })
            } finally {
                this.spinning = false
            }
        }
    }
}
</script>

<style scoped lang="less">
// KPI 卡片
.kpi-cards-container { margin-bottom: 16px; }
.kpi-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.3s;
    overflow: hidden;
    &:hover { box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12); transform: translateY(-2px); }
    .ant-card-body { padding: 20px; }
}
.kpi-content { display: flex; align-items: center; gap: 16px; }
.kpi-icon {
    width: 56px; height: 56px; border-radius: 12px;
    display: flex; align-items: center; justify-content: center;
    font-size: 24px; flex-shrink: 0; color: white;
}
.kpi-card-primary .kpi-icon { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.kpi-card-info .kpi-icon { background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%); }
.kpi-card-success .kpi-icon { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }
.kpi-card-warning .kpi-icon { background: linear-gradient(135deg, #fa709a 0%, #fee140 100%); }
.kpi-details { flex: 1; min-width: 0; }
.kpi-label { font-size: 14px; color: rgba(0, 0, 0, 0.45); margin-bottom: 8px; font-weight: 500; }
.kpi-value { font-size: 24px; font-weight: 600; color: rgba(0, 0, 0, 0.85); line-height: 1.2; }

// 收款率卡片
.rate-card {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    border-radius: 8px;
    .ant-card-body { padding: 24px; }
}
.rate-content { display: flex; align-items: center; gap: 24px; }
.rate-label { font-size: 16px; font-weight: 500; color: rgba(0, 0, 0, 0.65); min-width: 100px; }
.rate-value { flex: 1; display: flex; align-items: center; gap: 16px; }
.rate-number { font-size: 32px; font-weight: 600; color: #1890ff; min-width: 100px; text-align: right; }
.rate-progress { flex: 1; }

// 图表与表格卡片
.chart-card, .table-card {
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    .chart-card &:hover { box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12); transition: all 0.3s; }
    .ant-card-head { border-bottom: 1px solid #f0f0f0; }
    .ant-card-head-title { font-size: 16px; font-weight: 600; }
}

// 卡片间距
.mb-4 {
    margin-bottom: 16px;
}

// 表格样式
.dept-name { font-weight: 500; color: rgba(0, 0, 0, 0.85); }
.money-text { font-family: 'Consolas', 'Monaco', monospace; font-weight: 600; }
.money-received { color: #52c41a; }
.money-pending { color: #faad14; }
.rate-cell {
    display: flex; justify-content: center; align-items: center;
    ::v-deep .ant-progress-text { font-size: 12px !important; }
}
.ant-table-tbody > tr:hover > td { background-color: #f5f5f5 !important; }
.ant-tag { font-weight: 500; }

// 响应式
@media (max-width: 768px) {
    .kpi-content { flex-direction: column; text-align: center; gap: 12px; }
    .kpi-icon { width: 48px; height: 48px; font-size: 20px; }
    .kpi-value { font-size: 20px; }
    .rate-content { flex-direction: column; gap: 16px; }
    .rate-label { text-align: center; }
    .rate-value { flex-direction: column; width: 100%; }
    .rate-number { font-size: 28px; text-align: center; width: 100%; }
    .rate-progress { width: 100%; }
}
</style>
